import React, { FC } from 'react';

import { ListCards } from '@/components/molecules/ListCards/render';

import block from './block.json';

/**
 * COMPONENT
 */
export const ListButtons: FC<ListCardsProps> & BlockConfigs = (props) => {
	return <ListCards {...props} />;
};

ListButtons.slug = block.slug;
ListButtons.title = block.title;
